import { inject, Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../../../amplify/data/resource';
import { PosthogService } from './posthog.service';

@Injectable({
  providedIn: 'root'
})

export class AiService {
  private _client?: ReturnType<typeof generateClient<Schema>>;

  private get client() {
    if (!this._client) {
      this._client = generateClient<Schema>();
    }
    return this._client;
  }

  private posthogService = inject(PosthogService);

  async askMistral(question: string, system:string): Promise<string> {
    try {
      if(this.posthogService.featureFlagAI()){

        const { data, errors } = await this.client.queries.callAi({
          system: system,
          content: question,
        });
        if (errors) {
          console.error("Error GraphQL:", errors);
          return "ERROR";
        }
        return data || "No data";
      }else{
        console.error('Feature AI is disabled');
        return 'Feature AI blocked by feature flag';
      }
    } catch (e) {
      console.error("Network error :", e);
      return "Network error.";
    }
  }
}
